// @flow
import React from "react";
import PropTypes from "prop-types";
import LIButton from "../GUI_COMMON/COMPONENTS/LIButton";

const NotificationButton = ({numUnread, numNotifs, onClick}) => {
    
    if(numNotifs===0) {
        return null;
    }
    
    function handleClicked(e) {
        if(onClick) {
            onClick();
        }
    }
    
    const flashClass = numUnread>20?"li-flash":null;
    
    return (
        <div className={"position-relative "+flashClass}>
            <LIButton faIcon="fa fa-envelope fa-1_5x" bgClass="li-notification-icon" tooltip="notifications" onClick={handleClicked}/>
            {numUnread>0?<span className="li-num-unread-badge badge">{numUnread}</span>:null}
            </div>
    );
}

NotificationButton.propTypes =  { 
    numUnread: PropTypes.number.isRequired,
    numNotifs: PropTypes.number.isRequired,
    onClick: PropTypes.func,
}

export default NotificationButton;